/* Hard4Life — springt beim Laden und beim Farbwechsel automatisch
   auf die erste WIRKLICH verfügbare Größe, statt stur bei der ersten
   Variante (oft eine ausverkaufte Kindergröße) zu bleiben. */
(function () {
  function pruefeUndKorrigiere(root) {
    var script = root.querySelector('script[data-selected-variant]');
    if (!script) return;
    var aktuelle;
    try { aktuelle = JSON.parse(script.textContent); } catch (e) { return; }
    if (!aktuelle || aktuelle.available) return;

    var alle = [];
    try {
      var block = document.querySelector('script[type="application/json"][id^="ProductJSON-"]');
      if (block) alle = JSON.parse(block.textContent).variants || [];
    } catch (e) {}
    if (!alle.length) return;

    var ziel =
      alle.find(function (v) {
        return v.available && v.options[1] === aktuelle.options[1];
      }) ||
      alle.find(function (v) { return v.available; });
    if (!ziel || ziel.id === aktuelle.id) return;

    ziel.options.forEach(function (wert, i) {
      var eingaben = root.querySelectorAll(
        'input[type="radio"][value="' + CSS.escape(wert) + '"], option[value="' + CSS.escape(wert) + '"]'
      );
      eingaben.forEach(function (el) {
        var feld = el.closest('fieldset, .product-form__input--dropdown');
        if (!feld) return;
        var gehoertZuOption = feld.querySelector('legend, label');
        if (el.tagName === 'INPUT') {
          el.checked = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (el.tagName === 'OPTION') {
          el.selected = true;
          el.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function starten() {
    document.querySelectorAll('variant-selects').forEach(pruefeUndKorrigiere);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
  document.addEventListener('shopify:section:load', starten);

  document.addEventListener('change', function (e) {
    var root = e.target.closest('variant-selects');
    if (root) setTimeout(function () { pruefeUndKorrigiere(root); }, 150);
  });
})();
